import { render, staticRenderFns } from "./EditExpenses.vue?vue&type=template&id=9c0610c6&scoped=true"
import script from "./EditExpenses.vue?vue&type=script&lang=js"
export * from "./EditExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0610c6",
  null
  
)

export default component.exports